module.exports = __webpack_public_path__ + "img/bt 1.0baf3bbd.svg";